import { useTranslation } from 'react-i18next'
import { ENotEditableReason } from '../messages/_components/programmed-message.type'
import { getNotEditableReasonLabel } from '../messages/_components/not-editable-message.helper'

const TimelineMessageItemMenu = ({
  isEditable,
  notEditableReason,
  onEdit,
  onDuplicate,
  onDelete,
}: {
  isEditable: boolean
  notEditableReason: ENotEditableReason | null
  onEdit: () => void
  onDuplicate: () => void
  onDelete: () => void
}) => {
  const { t } = useTranslation()

  return (
    <div className="c-absolute c-shadow-xl c-left-0 c-top-[calc(100%+4px)] c-w-72 c-z-10 c-border c-border-grey-500 c-bg-white c-rounded-md c-overflow-hidden">
      {isEditable ? (
        <>
          <button
            onClick={onEdit}
            className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-border-b c-border-grey-500"
          >
            {t('pages.configuration.messages.menu.edit')}
          </button>
          <button
            onClick={onDuplicate}
            className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-border-b c-border-grey-500"
          >
            {t('pages.configuration.messages.menu.duplicate')}
          </button>
          <button
            onClick={onDelete}
            className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-text-red-600"
          >
            {t('pages.configuration.messages.menu.delete')}
          </button>
        </>
      ) : (
        <p className="c-px-4 c-py-3 c-text-sm c-text-grey-600 c-m-0">
          {getNotEditableReasonLabel(t, notEditableReason)}
        </p>
      )}
    </div>
  )
}

export { TimelineMessageItemMenu }
